export enum Admin {
  CURRENCY = 'currency',
  CURRENCYCODE = 'currencyCode',
  DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE',
  HOMEMESSAGE_EN = 'HomeMessage_en',
  HOMEMESSAGE_ES = 'HomeMessage_es',
  STORE = 'store',
  LOCATION = 'Location',
  COUNTRY = 'country',

  LOCALES = 'LOCALES',
  MALETAS25KG = 'maletas25KG',
  BAGTAG = 'bagTag',
  DISABLE_SEAT_MAP = 'DISABLE_SEAT_MAP',
  DOCV = 'DOCV',
  HANDLE_OVER_WEIGHT_BAG = 'HANDLE_OVERWEIGHT_BAG',
  NO_PASSPORT_SCANNER = 'noPassportScanner',
  OUT_OF_SERVICE = 'outOfService',
  PAYMENT = 'Payment',
  SCALE = 'scale',
  SHOW_OVER_BOOKING_VOLUNTEER_OFFER = 'SHOW_OVERBOOKING_VOLUNTEER_OFFER',
  SHOW_PREMIERE_OFFER = 'SHOW_PREMIERE_OFFER',
  SHOW_SEAT_SELECT_PREMIERE_OFFER = 'SHOW_SEAT_SELECT_PREMIERE_OFFER',
  TSA = 'TSA',
  WAIT_FOR_AGENT = 'WAIT_FOR_AGENT',
  AM_PLUS_UPSELL = 'AM_PLUS_UPSELL',
  PAYMENT_AND_WHEIHT_TEST = '',
  INTERNATIONAL_ROUTES = 'INTERNATIONALROUTES',
  KIOSK_VERTICAL_SCREEN = 'KIOSK_VERTICAL_SCREEN',
  USA_REQUERIMENTS = 'USA_REQUIREMENTS',
  SHOW_IROPS = 'showIrops',
  SHOW_USPERSON = 'showUSPerson',
  PORT_PINPAD = 'portPinpad',
  NUMBER_OF_DECIMALS_BE = 'numberOfDecimalsBE',
  ENABLE_SPECIAL_COLOR_LABELS = 'enableSpecialColorLabels',
}
